module.exports = "<symbol id=\"tt-icon-error\" viewBox=\"0 0 24 24\"><path d=\"M23.65 11.15L12.85.35a1.2 1.2 0 0 0-1.7 0L.35 11.15a1.2 1.2 0 0 0 0 1.7l10.8 10.8a1.21 1.21 0 0 0 1.7 0l10.8-10.8a1.2 1.2 0 0 0 0-1.7zM12 21.1L2.9 12 12 2.9l9.1 9.1z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M10.8 7.2h2.4v7.2h-2.4z\"/><circle cx=\"12\" cy=\"16.8\" r=\"1.5\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/VuTUYdwvqIExdDFsite/assets/svg/non-defined-page/error.svg
// module id = 167
// module chunks = 11